export default __webpack_public_path__ + "static/f5-acf689479027361d560ada5e78468828.png";